import React, { useState, useEffect } from "react";

// DevExtreme components
import HtmlEditor from 'devextreme-react/html-editor';

// Component styles
import classes from "./RichTextWidget.module.scss";

const EMPTY = undefined;

const toolbarOptions = {
  items: [
    "undo",
    "redo",
    "separator",
    "bold",
    "italic",
    "underline",
    "separator",
    "color",
    "background",
    "separator",
    "clear",
    "separator",
    "link",
    "separator",
    {
      "name": "header",
      "acceptedValues": [
        false,        
        1,
        2,
        3
      ]
    }
  ]
};

export function RichTextWidget(props) {
  const { ui, data, startWork, writeBack } = props;
  const widgetId = ui.id;

  const [localContent, setLocalContent] = useState(EMPTY);

  let content = localContent !== EMPTY ? localContent : data && data.content ? data.content : "";
  let disabled = ui.readonly || (data && data.readonly);

  useEffect(() => {
    console.log("RichTextWidget data of " + ui.id + ": ", data);
    setLocalContent(EMPTY);
  }, [data]);

  return (
    <HtmlEditor
      id={widgetId}
      className={classes.editor}
      value={content}
      valueType="html"
      onValueChanged={e => { startWork(); setLocalContent(e.value);}}
      onFocusOut={() => writeBack(content)}
      disabled={disabled}
      toolbar={toolbarOptions}
      height="100%"
    />
  );
}